// External imports
import React from 'react'

const Loader = () => {
    return (
        <React.Fragment>
            <div className="loader-main">
                <div className="loader-wrap">
                    <div className="loader"></div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Loader;